import React from "react";
import { useTable, usePagination } from "react-table";
import {
  Link
} from "react-router-dom";
import "./reactTable.css";
import DeleteIcon from "@material-ui/icons/Delete";
import DetailsIcon from "@material-ui/icons/Details";
import Tooltip from "@material-ui/core/Tooltip";
import GetAppIcon from "@material-ui/icons/GetApp";
import FindReplaceIcon from "@material-ui/icons/FindReplace";
import { Document, Page, pdfjs } from "react-pdf";
import { withStyles } from "@material-ui/core/styles";
import { red } from "@material-ui/core/colors";
import { Box, Grid, FormControlLabel, Checkbox } from "@material-ui/core";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const defaultPropGetter = () => ({});
const defaultPropGetterCells = () => ({});

function TableControlled({
  linkColumns,
  replaceFunction,
  detailsFunction,
  deleteFunction,
  checkBoxFunction,
  columns,
  data,
  filters,
  fetchData,
  loading,
  pageCount: controlledPageCount,
  pageSize: controlledPageSize,
  getRowProps = defaultPropGetter,
  getCellProps = defaultPropGetterCells,
}) {
  //Window resize state variables for images in a table
  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }
    window.addEventListener("resize", handleResize);
  });

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    pageSize,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    // Get the state from the instance
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 }, // Pass our hoisted table state
      manualPagination: true, // Tell the usePagination
      // hook that we'll handle our own data fetching
      // This means we'll also have to provide our own
      // pageCount.
      pageCount: controlledPageCount,
      pageSize: controlledPageSize
    },
    usePagination
  );

  const RedCheckBox = withStyles({
    root: {
      color: red[400],
      '&$checked': {
        color: red[400],
      },
    },
    checked: {},
  })((props) => <Checkbox color="primary" {...props} />);

  // Render the UI for your table
  return (
    <>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? " 🔽"
                        : " 🔼"
                      : ""}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);

            return (
              <tr {...row.getRowProps(getRowProps(row))}>
                {row.cells.map((cell) => {
                  if (cell.column.id === "details") {
                    return (
                      <td onClick={e => e.stopPropagation()} key={cell.column.id}>
                        <Tooltip disableFocusListener title="Open Details">
                          <DetailsIcon
                            onClick={() => detailsFunction(row.index)}
                          />
                        </Tooltip>
                      </td>
                    );
                  } else if (cell.column.id === "delete") {
                    return (
                      <td onClick={e => e.stopPropagation()} key={cell.column.id}>
                        <Tooltip disableFocusListener title="Delete">
                          <DeleteIcon onClick={() => deleteFunction(row.index)} />
                        </Tooltip>
                      </td>
                    );
                  } else if (cell.column.id === "replace") {
                    return (
                      <td
                        onClick={(e) => e.stopPropagation()}
                        key={cell.column.id}
                      >
                        <Tooltip disableFocusListener title="Replace">
                          <button>
                            <FindReplaceIcon
                              onClick={() => replaceFunction(row.index)}
                            />
                          </button>
                        </Tooltip>
                      </td>
                    );
                  } else if (cell.column.id === "download") {
                    const data = cell.row.allCells[0].value;
                    const DownloadLink = ({ data }) => (
                      <a download href={require("../" + data)}>
                        <Tooltip disableFocusListener title="Download">
                          <button>
                            <GetAppIcon />
                          </button>
                        </Tooltip>
                      </a>
                    );
                    return (
                      <td
                        onClick={(e) => e.stopPropagation()}
                        key={cell.column.id}
                      >
                        <DownloadLink data={data} />
                      </td>
                    );
                  } else if (cell.column.id === "msa_file") {
                    const data = cell.value;
                    const Img = (
                      { data } //<embed type="application/pdf" src={`data:application/pdf;base64,${data}`}/>
                    ) => (
                      <>{data === ''?<></>:
                      <Document file={require("../"+data)}>
                        <Page
                          pageNumber={1}
                          width={dimensions.width > 960 ? 250 : 80}
                          height={dimensions.width > 960 ? 250 : 80}
                        />
                      </Document>}
                      </>
                    );

                    return (
                      <td
                        onClick={(e) => e.stopPropagation()}
                        key={cell.column.id}
                      >
                        <Img data={data} />
                      </td>
                    );
                  } else if (cell.column.id === "checkbox")
                  {
                    if (cell.row.original.isStandAlone){//Specifically for the standAloneCO checkbox due to the unique hovering text
                      return (
                        <td
                          onClick={(e) => e.stopPropagation()}
                          key={cell.column.id}
                        >
                          <Tooltip disableFocusListener title="Stand Alone?">
                            <FormControlLabel
                              disabled={false}
                              control={
                              <RedCheckBox
                                onChange={() => checkBoxFunction(row.index)}
                                checked={cell.row.original.isStandAlone}
                              />
                              }
                            />
                          </Tooltip>
                        </td>
                      );
                    } 
                    
                    if (cell.row.original.checkbox !== null) {//Generic checkbox implementation in the table
                      return (
                        <td
                          onClick={(e) => e.stopPropagation()}
                          key={cell.column.id}
                        >
                          <Tooltip disableFocusListener>
                            <FormControlLabel
                              disabled={false}
                              control={
                              <RedCheckBox
                                onChange={() => checkBoxFunction(row.index)}
                                checked={cell.row.original.checkbox}
                              />
                              }
                            />
                          </Tooltip>
                        </td>
                      );
                    }
                  } else {
                    if (linkColumns){
                      if (linkColumns.map(column => column.Header).includes(cell.column.Header)){
                        return (
                          <td {...cell.getCellProps(getCellProps(cell))}>
                            <Link to={{pathname: linkColumns.filter(col => col.Header===cell.column.Header)[0].path, state:{ ...cell.row.original, ...(linkColumns.filter(col => col.Header===cell.column.Header)[0].props)}}}>
                              {cell.render("Cell")}
                            </Link>
                          </td>
                        );
                      } else {
                        return (
                          <td {...cell.getCellProps(getCellProps(cell))}>{cell.render("Cell")}</td>
                        );
                      }
                    } else {
                      return (
                        <td {...cell.getCellProps(getCellProps(cell))}>{cell.render("Cell")}</td>
                      );
                    }
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {/* 
        Pagination can be built however you'd like. 
        This is just a very basic UI implementation:
      */}
      {loading ? <h1> Loading... </h1> : <></>}
      <div className="pagination">
        <button
          onClick={() => {
            gotoPage(0);
            fetchData(0, pageSize, filters);
          }}
          disabled={!canPreviousPage}
        >
          {"<<"}
        </button>{" "}
        <button
          onClick={() => {
            previousPage();
            fetchData(pageIndex - 1, pageSize, filters);
          }}
          disabled={!canPreviousPage}
        >
          {"<"}
        </button>{" "}
        <button
          onClick={() => {
            nextPage();
            fetchData(pageIndex + 1, pageSize, filters);
          }}
          disabled={!canNextPage}
        >
          {">"}
        </button>{" "}
        <button
          onClick={() => {
            gotoPage(pageCount - 1);
            fetchData(pageCount - 1, pageSize, filters);
          }}
          disabled={!canNextPage}
        >
          {">>"}
        </button>{" "}
        <span>
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{" "}
        </span>
        <span>
          | Go to page:{" "}
          <input
            type="number"
            value={pageIndex + 1}
            disabled={!canNextPage}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              gotoPage(page);
              fetchData(
                Math.min(Math.max(1, page), pageCount),
                pageSize,
                filters
              );
            }}
            style={{ width: "100px" }}
          />
        </span>{" "}
        <select
          defaultValue={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
            fetchData(
              (pageSize / e.target.value) * pageIndex,
              Number(e.target.value),
              filters
            );
          }}
        >
          {[10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
    </>
  );
}
export default TableControlled;
